import { NumericFormat, NumericFormatProps } from 'react-number-format';

import { TextField } from '@mui/material';

function convertToNumber(val: any) {
  if (typeof val === 'string') {
    return parseFloat(val.replace(',', '.')); // replace comma with dot
  }

  return val;
}

interface Props extends NumericFormatProps {
  label: string;
  error?: boolean;
  helperText?: string | null;
  onChange: (value: any) => void;
}

export default function NumberField({
  label,
  value,
  onChange,
  error,
  helperText,
  decimalScale = 2,
  decimalSeparator = ',',
  required
}: Props) {
  return (
    <NumericFormat
      label={label}
      decimalScale={decimalScale}
      decimalSeparator={decimalSeparator}
      required={required}
      customInput={TextField}
      value={convertToNumber(value)}
      onValueChange={({ value }) => onChange(convertToNumber(value))}
      error={error}
      helperText={helperText}
    />
  );
}
